import React from "react";
import { Breadcrumb } from "../components/shared/Breadcrumb";
import { ButtonLink } from "../components/shared/Button";
import { RooflineDivider } from "../components/shared/RooflineDivider";
import { PageMeta } from "../components/shared/PageMeta";

// About → Bricks page. Owner bios, qualifications and portraits omitted until supplied and approved.
const team = [{
  name: "Tommy Bramley",
  role: "Owner, Oceanside Living",
  bio: "",
  image: ""
}, {
  name: "Justin Pike",
  role: "Owner, Oceanside Living",
  bio: "",
  image: ""
}];
export function About() {
  return <>
      <PageMeta title="About Oceanside Living | Owner-Led Perth Home Builders" description="Meet Oceanside Living, an owner-led Perth home builder run by Tommy Bramley and Justin Pike, who invest in their own developments." data-id="element-594" data-mp="2sadbx5bdat6y" />
      <div className="mx-auto max-w-site px-5 pb-16 pt-10 md:px-10 md:pb-28 md:pt-14" data-id="element-595" data-mp="1gtemzdo541u8">
        <Breadcrumb items={[{
        label: "Home",
        to: "/"
      }, {
        label: "About"
      }]} data-id="element-596" data-mp="1lv4337q7z5p6" />
        <h1 className="mt-6 max-w-3xl text-[38px] font-semibold leading-[1.08] tracking-tight md:text-[60px]" data-id="element-597" data-mp="1uha2hovprivi">
          Homes we’d be proud to own ourselves.
        </h1>
        <p className="mt-6 max-w-2xl text-[17px] leading-relaxed text-slate md:text-lg" data-id="element-598" data-mp="23igizxyd4tor">
          Oceanside Living is an owner-led Perth home builder. We actively invest in our own developments and put our own money on
          the line, so we bring that same care, understanding and accountability to your building decisions. Our directors bring
          over 30 years of combined experience in the WA construction industry, with deep local knowledge and established trade
          networks. As a small and experienced team, we carefully manage our workload so each home receives the attention,
          quality and consistent communication it needs.
        </p>

        <RooflineDivider className="mt-14 text-line" data-id="element-599" data-mp="2w7f4n51p2dyt" />

        <section aria-labelledby="owners-heading" className="mt-14 grid gap-10 lg:grid-cols-12" data-id="element-600" data-mp="2r8u22yyyzi77">
          <div className="lg:col-span-5" data-id="element-601" data-mp="1ov67nbg4ob05">
            <h2 id="owners-heading" className="text-[28px] font-semibold tracking-tight md:text-[40px]" data-id="element-602" data-mp="1owhe5j0yjwuy">The owners</h2>
            <p className="mt-4 text-[17px] leading-relaxed text-slate" data-id="element-603" data-mp="1stvjv0pfjmi7">You’ll be working with a hands-on team led by its owners.</p>
          </div>
          <ul className="grid gap-6 sm:grid-cols-2 lg:col-span-7" data-id="element-604" data-mp="22n2ylc628euy">
            {team.map(person => <li key={person.name} className="border-t border-charcoal pt-5" data-id="element-605" data-mp="27k2w2youg9ag">
                <p className="font-heading text-2xl font-semibold" data-id="element-606" data-mp="2cjpf5orcsjr6">{person.name}</p>
                <p className="mt-1 text-slate" data-id="element-607" data-mp="2gm2cppvy5bcv">{person.role}</p>
              </li>)}
          </ul>
        </section>

        <section aria-labelledby="mission-heading" className="mt-20 bg-white p-8 md:p-14" data-id="element-608" data-mp="2ljud78anq5so">
          <h2 id="mission-heading" className="text-[15px] font-semibold text-slate" data-id="element-609" data-mp="m8kywulcfsv1">Our mission</h2>
          <p className="mt-4 max-w-3xl font-heading text-[26px] font-semibold leading-snug tracking-tight md:text-[36px]" data-id="element-610" data-mp="r62yhudh0vqd">
            A personal, enjoyable and efficient home-building experience, from initial consultation through key handover and beyond.
          </p>
        </section>

        <div className="mt-16 flex flex-col gap-4 sm:flex-row" data-id="element-611" data-mp="9x0o1u2g80bb">
          <ButtonLink to="/contact" data-id="element-612" data-mp="9v7dw4smmxyk">Book a consultation</ButtonLink>
          <ButtonLink to="/projects" variant="secondary" data-id="element-613" data-mp="501v3euitzep">See our work</ButtonLink>
        </div>
      </div>
    </>;
}